import { Link } from "react-router-dom";
import "./Navigation.scss";
import settingsIcon from "assets/images/icons/ic_settings.svg";
import cartIcon from "assets/images/icons/cart_icon.svg";
import Logo from "assets/images/imgs/logo_en.svg";
import MainMenuIconList from "components/common/MainMenuIconList";

function Navigation({ hasMenu = false, hasCart = false, icons }) {
    // icons이 제공되면 MainMenuIconList 사용, 없으면 기존 방식 유지
    const defaultIcons = [];
    if (hasCart) {
        defaultIcons.push({
            id: "alert",
            name: "장바구니",
            icon: cartIcon,
            path: "/cart",
            hasNotification: false,
        });
    }
    if (hasMenu) {
        defaultIcons.push({
            id: "settings",
            name: "설정",
            icon: settingsIcon,
            path: "/settings",
            hasNotification: false,
        });
    }

    const iconList = icons || defaultIcons;

    return (
        <>
            <nav className="navigation">
                <div className="nav-container">
                    <Link to="/" className="nav-logo">
                        <img src={Logo} alt="DEEPS" />
                    </Link>

                    {iconList.length > 0 ? (
                        <MainMenuIconList icons={iconList} />
                    ) : (
                        <div className="btn-wrap"></div>
                    )}
                </div>
            </nav>
        </>
    );
}

export default Navigation;
